import React, {useEffect, useState} from "react";
import Button from "../../components/v2/Button";
import StepperCar from "../../components/v2/StepperCar";
import Input from "../../components/v2/Input";
import useValetStore from "./hooks/useValetStore";
import Swal from "sweetalert2";
import Alert, {ERROR, MAIL_ERROR, MAIL_SUCCESS, SUCCESS} from "../../components/v2/Alert";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

export default function ValetYourEmail() {
    const {
        callPost,
        valetIntent,
        userData
    } = useValetStore();

    const [email, setEmail] = useState(userData?.email ?? '');
    const [emailSent, setEmailSent] = useState(false);
    const [alreadyExistError, setAlreadyExistError] = useState(false);

    const formRef = React.useRef();

    const {t, i18n} = useTranslation('common');

    const nextClickedHandler = (e) => {
        setAlreadyExistError(false)
        if (!formRef.current.reportValidity()) {
            return;
        }
        callPost('quick_register', {
            user: {
                'email': email,
                'valet_intent_id': valetIntent.id,
                'language': i18n.language
            }
        }, (data) => {
            setEmail(email)
            setEmailSent(true)
        }, (failResultData) => {
            if (failResultData.message == 'register.error.email_already_exists') {
                setAlreadyExistError(true)
            }
        });
    }

    return <div className="h-full flex flex-col p-4 gap-4">
        <StepperCar value={30}/>
        <div className="text-white text-[30px] font-bold">
            {t('valet.email.title')}
        </div>
        {t('valet.email.text')}<br/><br/>
        {t('valet.email.text2')}

        <form ref={formRef} className="flex flex-col gap-4">
            <Input id="from_address" label={t('valet.email.text3')}
                   placeholder={t('valet.email.text4')}
                   value={email}
                   required={true}
                   onChange={(e) => setEmail(e)}
            />
            {emailSent ?
                <Alert type={MAIL_SUCCESS}
                       label={t('valet.email.text5')}
                       text={t('valet.email.text6')}
                />
                : null}
            {alreadyExistError ?
                <Link to="/login">
                    <Alert type={MAIL_ERROR}
                           label={t('valet.email.text7')}
                           text={<u>{t('valet.email.text8')}</u>}
                    />
                </Link>
                : null}
        </form>

        <div className="grow">
        </div>
        {!emailSent ?
            <Button text={t('valet.email.btn_continue')} clickHandler={nextClickedHandler}/>
            : null}
    < /div>
}